document.addEventListener("DOMContentLoaded", function() {
    // Create outer cursor ring
    const outerCursor = document.createElement("div");
    outerCursor.classList.add("custom-cursor-outer");
    document.body.appendChild(outerCursor);

    // Create inner cursor dot
    const innerCursor = document.createElement("div");
    innerCursor.classList.add("custom-cursor-inner");
    document.body.appendChild(innerCursor);

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    
    // Inner cursor position (follows closely)
    let innerX = mouseX;
    let innerY = mouseY;
    
    // Outer cursor position (follows with delay)
    let outerX = mouseX;
    let outerY = mouseY;

    // Initialize cursor positions
    innerCursor.style.left = innerX + "px";
    innerCursor.style.top = innerY + "px";
    outerCursor.style.left = outerX + "px";
    outerCursor.style.top = outerY + "px";

    // Update cursor positions with different speeds
    function updateCursor() {
        // Inner cursor follows quickly (0.15 = fast)
        const innerDx = mouseX - innerX;
        const innerDy = mouseY - innerY;
        innerX += innerDx * 0.15;
        innerY += innerDy * 0.15;
        
        // Outer cursor follows slowly (0.05 = slow, creates trailing effect)
        const outerDx = mouseX - outerX;
        const outerDy = mouseY - outerY;
        outerX += outerDx * 0.05;
        outerY += outerDy * 0.05;
        
        innerCursor.style.left = innerX + "px";
        innerCursor.style.top = innerY + "px";
        outerCursor.style.left = outerX + "px";
        outerCursor.style.top = outerY + "px";
        
        requestAnimationFrame(updateCursor);
    }

    // Track mouse movement
    document.addEventListener("mousemove", (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    // Handle click animation - both cursors expand
    document.addEventListener("mousedown", () => {
        innerCursor.classList.add("cursor-clicked");
        outerCursor.classList.add("cursor-clicked");
    });

    document.addEventListener("mouseup", () => {
        innerCursor.classList.remove("cursor-clicked");
        outerCursor.classList.remove("cursor-clicked");
    });

    // Handle hover effects on interactive elements
    const interactiveElements = document.querySelectorAll('a, button, input, textarea, select, [role="button"]');
    
    interactiveElements.forEach(element => {
        element.addEventListener("mouseenter", () => {
            innerCursor.classList.add("cursor-hover");
            outerCursor.classList.add("cursor-hover");
        });
        
        element.addEventListener("mouseleave", () => {
            innerCursor.classList.remove("cursor-hover");
            outerCursor.classList.remove("cursor-hover");
        });
    });

    // Start cursor animation
    updateCursor();
});

